'use client';

import { VideoDescription as CoreVideoDescription } from '@portals/help-center-core/lib/_internal';
import React from 'react';

type TProps = Parameters<typeof CoreVideoDescription>[0];

export const VideoDescription = (props: TProps) => (
  <CoreVideoDescription {...props} />
);
